import type { Component } from 'vue';
import type { ResolvedNavigationModel } from '@/stores/content';
import { resolveMenuIcon } from '@/nav/lucideNavIcons';

export function normalizePath(path: string | undefined): string {
  if (!path) return '/';
  const p = path.startsWith('/') ? path : `/${path}`;
  return p.endsWith('/') ? p : `${p}/`;
}

export type TopMenuLinkView = {
  id: number;
  sectionKey: string;
  path: string;
  label: string;
  icon: Component;
};

export type TopMenuChildLink = { path: string; label: string };

export function buildTopMenuChildrenByKey(
  resolvedTopMenu: ResolvedNavigationModel['topMenuLinks']
): Map<string, TopMenuChildLink[]> {
  const byKey = new Map<string, TopMenuChildLink[]>();
  for (const item of resolvedTopMenu) {
    const children = item.children.map((child) => ({
      path: child.url ?? '/',
      label: child.title ?? '',
    }));
    const sectionKey = item.translation_key ?? String(item.id);
    byKey.set(sectionKey, children);
  }
  return byKey;
}

export function mapTopMenuLinksToView(
  resolvedTopMenu: ResolvedNavigationModel['topMenuLinks']
): TopMenuLinkView[] {
  return resolvedTopMenu.map((page) => ({
    id: page.id,
    sectionKey: page.translation_key ?? String(page.id),
    path: page.url ?? '/',
    label: page.title ?? '',
    icon: resolveMenuIcon(page.icon),
  }));
}
